import { Text } from "components/atoms/text/Text";
import { COLORS } from "styles/colors";
import styled from "styled-components";
import { calcRem } from "styles/theme";
import { FLEX } from "styles/flex";
import NormalConfirmModal from "../normal";

type Props = {
  onDelete: () => void;
  onConfirmDelete: () => void;
  label?: string;
};

export default function DeleteConfirmModal({
  onDelete,
  onConfirmDelete,
  label,
}: Props): JSX.Element {
  return (
    <NormalConfirmModal onConfirmCancel={onDelete} onConfirm={onConfirmDelete}>
      <DeleteTextWrapper>
        <Text fontSize={20} bold>
          Are you sure you want to delete this{" "}
          {label !== undefined ? label : "video"}?
        </Text>
        <Text fontSize={20} bold color={COLORS.COMPANY}>
          This {label !== undefined ? label : "video"} will be deleted
          permanently and cannot be recovered.
        </Text>
      </DeleteTextWrapper>
    </NormalConfirmModal>
  );
}
export const DeleteTextWrapper = styled.div`
  text-align: center;
  padding: 20px 0;
  line-height: ${calcRem(28)};
  ${FLEX.FlexCenterCenter};
  gap: 8px;
  flex-direction: column;

  * {
    word-break: break-word;
    white-space: normal;
  }
`;
